var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import useAsync from "react-use/lib/useAsync";
import { ZLBoltContext } from ".";
import { ZLBoltOptionsContext, ZLBoltStreamState } from "./ZLBolt";
export const ConciergeContext = React.createContext(undefined);
export function Concierge(props) {
    var _a;
    const concierge = useAsync(() => resolve(props.concierge), [props.concierge]);
    const options = useAsync(() => resolve(props.options), [props.options]);
    return React.createElement(ConciergeContext.Provider, { value: concierge.value },
        React.createElement(ZLBoltContext.Provider, { value: (_a = concierge.value) === null || _a === void 0 ? void 0 : _a._zlbolt },
            " ",
            React.createElement(ZLBoltOptionsContext.Provider, { value: options.value },
                React.createElement(ZLBoltStreamState, null, props.children))));
}
export function useConcierge() {
    return React.useContext(ConciergeContext);
}
function resolve(r) {
    return __awaiter(this, void 0, void 0, function* () {
        return r instanceof Promise ? yield r : r;
    });
}
